import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsList, getSellerList, updateGoodsPrice, postGoodsExport } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from "vuex";
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'OnlineShopStockManage',
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  data: function data() {
    return {
      stationBaseList: [],
      oilCodeDict: [],
      exportShow: false,
      listApi: getGoodsList,
      type: '',
      sellerOptions: [],
      multipleSelection: [],
      dialogVisible: false,
      formData: {
        goodsPrice: '',
        spuNo: '',
        sellerId: ''
      },
      rules: {
        goodsPrice: [{
          required: true,
          message: '请输入销售价',
          trigger: 'blur'
        }],
        sellerId: [{
          required: true,
          message: '请选择油站',
          trigger: 'blur'
        }]
      }
    };
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationBaseList.length; i++) {
        if (_this.stationBaseList[i].ID === id) {
          return _this.stationBaseList[i].stationName;
        }
      }

      return '';
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var sellerOptions;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');
              _context2.next = 3;
              return getSellerList({
                page: 1,
                pageSize: 999999,
                donNotShowLoading: true
              });

            case 3:
              sellerOptions = _context2.sent;
              _this.sellerOptions = sellerOptions.data.list;
              _this.searchInfo.sellerId = _this.sellerOptions[0].sellerId;

              _this.getTableData();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {
        sellerId: this.sellerOptions[0].sellerId
      };
      this.onSubmit();
    },
    onGoodsIn: function onGoodsIn() {
      this.$router.push({
        name: 'BianlidianGoodsIn'
      });
    },
    // 导出
    onExport: function onExport() {
      this.dialogVisible = true;
      this.exportShow = true;
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    onView: function onView(row) {
      var params = {
        sellerId: row.sellerId,
        spuNo: row.spuNo,
        goodsName: row.goodsName
      };
      this.$router.push({
        name: 'BianlidianGoodsDetail',
        params: params
      });
    },
    onUpdateGoodsPrice: function onUpdateGoodsPrice(row) {
      var that = this;
      that.dialogVisible = true;
      that.formData.spuNo = row.spuNo;
      that.formData.sellerId = row.sellerId;
      that.formData.goodsPrice = row.goodsPrice;
    },
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
      this.exportShow = false; // 导出或其他

      this.type = '';
      this.formData = {
        goodsPrice: '',
        spuNo: '',
        sellerId: ''
      };
      this.$refs['formData'].resetFields();
    },
    enterDialog: function enterDialog() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this2; // 导出或其他

                that.$refs['formData'].validate(function (valid) {
                  // eslint-disable-next-line no-empty
                  if (valid) {
                    if (that.exportShow) {
                      postGoodsExport({
                        'sellerId': that.formData.sellerId
                      }).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          window.open(res.data.fileUrl);
                          that.closeDialog();
                          that.getTableData();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                      console.log('提交代码', that.formData);
                    } else {
                      that.formData.goodsPrice = parseFloat(that.formData.goodsPrice.trim());
                      updateGoodsPrice(that.formData).then(function (res) {
                        // eslint-disable-next-line eqeqeq
                        if (res.code == 0) {
                          that.$message({
                            type: 'success',
                            message: res.msg
                          });
                          that.closeDialog();
                          that.getTableData();
                        } // eslint-disable-next-line handle-callback-err

                      }, function (err) {});
                    }
                  } else {
                    return false;
                  }
                });

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    setStartMap: function setStartMap() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var stationBaseData;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getDict('oilTankStatus');

              case 2:
                _this3.oilTankStatusDict = _context4.sent;
                _context4.next = 5;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 5:
                stationBaseData = _context4.sent;
                _this3.stationBaseList = stationBaseData.data.list;
                _context4.next = 9;
                return getDict('oilCode');

              case 9:
                _this3.oilCodeDict = _context4.sent;

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};